// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tMpC","largestCol":"styles_largestCol__1Qc8V","smallestCol":"styles_smallestCol__37NBC"};